<div class="min-h-dvh bg-slate-50 text-slate-900">
  <app-header />

  <main class="w-full px-4 sm:px-6 lg:px-10 xl:px-16 py-8">
    <router-outlet></router-outlet>
  </main>

  <app-footer />
  <app-cookie-banner />
</div>